/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChangeOwnPasswordRequestData } from '../model/changeOwnPasswordRequestData';
import { ChangeOwnPasswordResponseData } from '../model/changeOwnPasswordResponseData';
import { FeaturesForUserResponseData } from '../model/featuresForUserResponseData';
import { NoContentResult } from '../model/noContentResult';
import { QueueShortInfoListResponseData } from '../model/queueShortInfoListResponseData';
import { RequestUserStatusChangeRequestData } from '../model/requestUserStatusChangeRequestData';
import { SkillsForUserResponseData } from '../model/skillsForUserResponseData';
import { StatusesForUserResponseData } from '../model/statusesForUserResponseData';
import { UpdateAgentGreetingsRequestData } from '../model/updateAgentGreetingsRequestData';
import { UpdateAgentGreetingsRespondData } from '../model/updateAgentGreetingsRespondData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UsersService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Changes the password of the user.
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeOwnPassword(body?: ChangeOwnPasswordRequestData, observe?: 'body', reportProgress?: boolean): Observable<ChangeOwnPasswordResponseData>;
    public changeOwnPassword(body?: ChangeOwnPasswordRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChangeOwnPasswordResponseData>>;
    public changeOwnPassword(body?: ChangeOwnPasswordRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChangeOwnPasswordResponseData>>;
    public changeOwnPassword(body?: ChangeOwnPasswordRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChangeOwnPasswordResponseData>('post',`${this.basePath}/api/users/change-own-password`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExecuteIvrTargets(observe?: 'body', reportProgress?: boolean): Observable<QueueShortInfoListResponseData>;
    public getExecuteIvrTargets(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueueShortInfoListResponseData>>;
    public getExecuteIvrTargets(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueueShortInfoListResponseData>>;
    public getExecuteIvrTargets(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QueueShortInfoListResponseData>('get',`${this.basePath}/api/users/execute-ivr-targets`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFeaturesForUser(userId?: number, observe?: 'body', reportProgress?: boolean): Observable<FeaturesForUserResponseData>;
    public getFeaturesForUser(userId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FeaturesForUserResponseData>>;
    public getFeaturesForUser(userId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FeaturesForUserResponseData>>;
    public getFeaturesForUser(userId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FeaturesForUserResponseData>('get',`${this.basePath}/api/users/features-for-user`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequeueTargetsForCalls(observe?: 'body', reportProgress?: boolean): Observable<QueueShortInfoListResponseData>;
    public getRequeueTargetsForCalls(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForCalls(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForCalls(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QueueShortInfoListResponseData>('get',`${this.basePath}/api/users/requeue-targets-for-calls`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequeueTargetsForChats(observe?: 'body', reportProgress?: boolean): Observable<QueueShortInfoListResponseData>;
    public getRequeueTargetsForChats(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForChats(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForChats(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QueueShortInfoListResponseData>('get',`${this.basePath}/api/users/requeue-targets-for-chats`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequeueTargetsForMessages(observe?: 'body', reportProgress?: boolean): Observable<QueueShortInfoListResponseData>;
    public getRequeueTargetsForMessages(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForMessages(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueueShortInfoListResponseData>>;
    public getRequeueTargetsForMessages(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QueueShortInfoListResponseData>('get',`${this.basePath}/api/users/requeue-targets-for-messages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSkillsForUser(userId?: number, observe?: 'body', reportProgress?: boolean): Observable<SkillsForUserResponseData>;
    public getSkillsForUser(userId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillsForUserResponseData>>;
    public getSkillsForUser(userId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillsForUserResponseData>>;
    public getSkillsForUser(userId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SkillsForUserResponseData>('get',`${this.basePath}/api/users/skills-for-user`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStatusesForUser(userId?: number, observe?: 'body', reportProgress?: boolean): Observable<StatusesForUserResponseData>;
    public getStatusesForUser(userId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StatusesForUserResponseData>>;
    public getStatusesForUser(userId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StatusesForUserResponseData>>;
    public getStatusesForUser(userId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StatusesForUserResponseData>('get',`${this.basePath}/api/users/statuses-for-user`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param directoryNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserAvatar(directoryNumber: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getUserAvatar(directoryNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getUserAvatar(directoryNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getUserAvatar(directoryNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (directoryNumber === null || directoryNumber === undefined) {
            throw new Error('Required parameter directoryNumber was null or undefined when calling getUserAvatar.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'image/png',
            'image/gif',
            'image/jpeg'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/users/avatar/${encodeURIComponent(String(directoryNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Used to request a user status change of the Agent.
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public requestUserStatusChange(body?: RequestUserStatusChangeRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public requestUserStatusChange(body?: RequestUserStatusChangeRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public requestUserStatusChange(body?: RequestUserStatusChangeRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public requestUserStatusChange(body?: RequestUserStatusChangeRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/users/request-user-status-change`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Configure greeting files for the user.
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAgentGreetings(body?: UpdateAgentGreetingsRequestData, observe?: 'body', reportProgress?: boolean): Observable<UpdateAgentGreetingsRespondData>;
    public updateAgentGreetings(body?: UpdateAgentGreetingsRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpdateAgentGreetingsRespondData>>;
    public updateAgentGreetings(body?: UpdateAgentGreetingsRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpdateAgentGreetingsRespondData>>;
    public updateAgentGreetings(body?: UpdateAgentGreetingsRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UpdateAgentGreetingsRespondData>('post',`${this.basePath}/api/users/update-agent-greeting`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
